import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$expandPreSelectedRequiredChoiceSets',
  initialState: false,
  reducers: {
    setExpandPreSelectedRequiredChoiceSets(
      _,
      action: PayloadAction<boolean | undefined>,
    ) {
      return action.payload ?? false;
    },
  },
});

export const { setExpandPreSelectedRequiredChoiceSets } = slice.actions;

export default slice.reducer;
